import type { FC } from 'react'

type Props = {
  children: React.ReactNode
}

const PageRoot: FC<Props> = ({ children }) => {
  return <div>{children}</div>
}

export default PageRoot
